import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { I18nProvider } from './contexts/I18nContext';
import { LiveSessionProvider } from './contexts/LiveSessionContext';
import './styles/global.css';
import './styles/saju2you-theme.css';
import './styles/live-lounge.css';
import './styles/ssehada-theme.css'; // 화이트·세이지 공통 테마 (최종 오버라이드)
import { subscribePush } from './utils/pushSubscription';

// Service Worker 등록 (PWA + 푸시 알림)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(() => {
        // PWA 설치 사용자: 자동 푸시 구독 시도 (이미 권한 있으면 조용히 등록)
        if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
          subscribePush();
        }
      })
      .catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <I18nProvider>
          <ThemeProvider>
            <AuthProvider>
              <LiveSessionProvider>
                <App />
              </LiveSessionProvider>
            </AuthProvider>
          </ThemeProvider>
        </I18nProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
